import React from "react";

import Button from "@replo/design-system/components/button/Button";
import { Modal } from "@replo/design-system/components/modal/Modal";

interface DiscardDesignLibraryChangesModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

export const DiscardDesignLibraryChangesModal: React.FC<
  DiscardDesignLibraryChangesModalProps
> = ({ isOpen, onOpenChange, onConfirm, onCancel }) => {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title="Discard changes?"
      description="You have unsaved Design Library changes. If you leave now, your edits will be lost."
      footer={
        <div className="flex gap-3 justify-end">
          <Button size="base" variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button size="base" variant="danger" onClick={onConfirm}>
            Discard
          </Button>
        </div>
      }
      closeOnOverlayClick={false}
    />
  );
};
